import * as types from './constants';

// Get Account
export const getAccountRequest = data => (
  { type: types.GET_ACCOUNT_REQUEST, payload: data }
);

export const getAccountDone = data => (
  { type: types.GET_ACCOUNT_DONE, payload: data }
);

export const getAccountFailed = errors => (
  { type: types.GET_ACCOUNT_FAILED, payload: errors }
);

export const updateAvatarUrl = data => (
  { type: types.UPDATE_AVATAR_URL, payload: data }
);